import { getInceptionStatusText } from '@/queries/family_applications/requests.ts'
import Badge, { ColorType } from '@/common/components/Badge.tsx'

export type InceptionStatusBadgeProps = {
  status: number
  className?: string
}

export default function InceptionStatusBadge({
  status,
  className,
}: InceptionStatusBadgeProps) {
  const validStatusText = getInceptionStatusText(status)
  let color: ColorType
  switch (status) {
    case 0:
      color = 'Positive'
      break
    case 1:
    case 2:
    case 3:
      color = 'Notice'
      break
    default:
      color = 'Neutral'
  }
  return (
    <Badge semanticColor={color} className={className}>
      {validStatusText}
    </Badge>
  )
}
